import { render } from "./vendors-list.vue?vue&type=template&id=2ed007f5"
import script from "./vendors-list.vue?vue&type=script&lang=js"
export * from "./vendors-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__